import { render } from "./HistoirePage.vue?vue&type=template&id=06512209"
import script from "./HistoirePage.vue?vue&type=script&lang=js"
export * from "./HistoirePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__